import styled from 'styled-components';
import { gradientYellowDark, gradientYellowLight, white } from 'styles/Colors';

export const BpPlaceholderPlayWrapper = styled.div`
  background: linear-gradient(112.13deg, #919191 0%, #dbdbdb 100%);
  border-radius: 5px;
  color: ${white};
  padding: 6px 9px 3px 9px;
  margin-bottom: 5px;
  cursor: pointer;

  .linear-loader .bar {
    background: #a0a0a0;
  }

  &.selected {
    background: linear-gradient(112.13deg, #fe9800 0%, #ffc900 100%);

    .linear-loader .bar {
      background: linear-gradient(140.12deg, ${gradientYellowDark} 0%, ${gradientYellowLight} 100%);
    }
  }

  &.hidden {
    display: none;
  }
`;

export const Text = styled.div`
  font-family: Oswald;
  font-weight: 500;
  font-size: 27px;
  line-height: 23px;
  padding-top: 4px;
  padding-bottom: 2px;
  text-transform: uppercase;
`;
